import { Controller } from "@hotwired/stimulus"

// Liga um link/botão a um conjunto de checkboxes: cada clique no link
// inverte o estado de todos os checkboxes (com base no estado do primeiro).
// Use data-toggle-all-checkboxes-selector-value para customizar quais
// checkboxes contam (padrão: input[type=checkbox]:not(.unclickable)).
export default class extends Controller {
  static values = {
    selector: { type: String, default: 'input[type="checkbox"]:not(.unclickable)' }
  }

  toggle(event) {
    event.preventDefault()
    const checkboxes = this.element.querySelectorAll(this.selectorValue)
    if (checkboxes.length === 0) return
    const newState = !checkboxes[0].checked
    checkboxes.forEach(cb => { cb.checked = newState })
  }
}
